import { Box, Skeleton } from "@mui/material";

export const SkeletonFallback = () => (
  <Box
    sx={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 4,
    }}
  >
    <Box sx={{ width: '100%', maxWidth: 600 }}>
      <Skeleton variant="rectangular" width="100%" height={50} />
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="40%" />
      <Skeleton variant="rectangular" width="100%" height={50} />
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="40%" />
      <Skeleton variant="rectangular" width="100%" height={50} />
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="40%" />
    </Box>
  </Box>
);
